export default __webpack_public_path__ + "img/home.c862f4bf.svg";